import React, { useEffect, useState } from 'react';
import { List, Button, Badge, message, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import api from '../../services/api';

export const RequestsPanel: React.FC = () => {
  const [items, setItems] = useState<any[]>([]);
  const load = async () => {
    try {
      const res = await api.get('/appointments/requests');
      setItems(res.data || []);
    } catch {
      // non-fatal: leave list empty
    }
  };
  useEffect(() => { load(); }, []);

  const act = async (id: number, action: 'accept' | 'decline') => {
    try {
      await api.post(`/appointments/${id}/${action}`, {});
      message.success(action === 'accept' ? 'Confirmed' : 'Declined');
      load();
    } catch {
      message.error('Action failed');
    }
  };

  if (items.length === 0) return null;
  return (
    <div style={{ marginBottom: 16 }}>
      <Badge count={items.length}>
        <Typography.Text strong>Pending requests</Typography.Text>
      </Badge>
      <List
        dataSource={items}
        renderItem={(a: any) => (
          <List.Item actions={[
            <Button key="a" type="primary" size="small" onClick={() => act(a.id, 'accept')}>Accept</Button>,
            <Button key="d" danger size="small" onClick={() => act(a.id, 'decline')}>Decline</Button>,
          ]}>
            <Space direction="vertical" size={0}>
              <Typography.Text>{a.title}</Typography.Text>
              <Typography.Text type="secondary">{dayjs(a.start_time).format('ddd MMM D, h:mm A')}</Typography.Text>
            </Space>
          </List.Item>
        )}
      />
    </div>
  );
};
